"use client";

import React, { useEffect, useRef, useState } from "react";
import { signOut, useSession } from "next-auth/react";
import Link from "next/link";
import { getStyledIcon } from "@litonarefin/utils/getStyledIcon";
import { getIcon } from "@litonarefin/utils/icons";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@litonarefin/utils";

const HeaderAccount = () => {
  const [isOpenAuthor, setIsOpenAuthor] = useState(false);

  const { data: session, status } = useSession();
  const wrapperRef = useRef(null);

  /**
   * Alert if clicked on outside of element
   */
  function handleClickOutside(event) {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpenAuthor(false);
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <>
      {session?.user?.id ? (
        <div className="jlt-relative jlt-ml-6">
          <div className="jlt-relative" ref={wrapperRef}>
            <img
              className="jlt-rounded-full jlt-cursor-pointer jlt-border"
              src={session?.user?.avatarUrl}
              alt="Profile Image"
              width={32}
              height={32}
              onClick={() => setIsOpenAuthor(!isOpenAuthor)}
            />
            {isOpenAuthor ? (
              <div className="jlt-absolute jlt-top-12 jlt-right-[calc(100%-40px)] jlt-w-44 jlt-pb-1 jlt-rounded-lg jlt-bg-white jlt-shadow-[0px_0px_8px_rgba(214,214,214,0.78)] before:jlt-content-[''] before:jlt-absolute before:jlt-w-4 before:jlt-h-4 before:jlt-bg-white before:jlt-rotate-45 before:-jlt-top-1 before:jlt-right-4">
                <div className="jlt-pt-4 jlt-px-4">
                  <p className="jlt-text-sm">{session?.user?.displayName}</p>
                </div>
                <hr className="jlt-mt-2 jlt-mb-1 jlt-mx-2" />
                <div className="jlt-flex jlt-flex-col jlt-gap-1">
                  <Link
                    className="jlt-text-[#256EFF] jlt-border-l-0 hover:jlt-border-l-4 jlt-transition-all jlt-duration-100 jlt-border-[#256EFF] jlt-py-1 jlt-pl-4 jlt-flex jlt-items-center jlt-gap-2"
                    href={"/dashboard/orders"}
                  >
                    {getStyledIcon(getIcon("orders"), "var(--primary)", "stroke", {
                      width: "16px",
                      height: "16px",
                    })}
                    <span className="jlt-text-sm jlt-font-medium">Orders</span>
                  </Link>
                  <hr className="jlt-mx-2" />
                  <Link
                    className="jlt-text-[#256EFF] jlt-border-l-0 hover:jlt-border-l-4 jlt-transition-all jlt-duration-100 jlt-border-[#256EFF] jlt-py-1 jlt-pl-4 jlt-flex jlt-items-center jlt-gap-2"
                    href={"/dashboard/downloads"}
                  >
                    {getStyledIcon(getIcon("orders"), "var(--primary)", "stroke", {
                      width: "16px",
                      height: "16px",
                    })}
                    <span className="jlt-text-sm jlt-font-medium">Downloads</span>
                  </Link>
                  <hr className="jlt-mx-2" />
                  <Link
                    className="jlt-text-[#256EFF] jlt-border-l-0 hover:jlt-border-l-4 jlt-transition-all jlt-duration-100 jlt-border-[#256EFF] jlt-py-1 jlt-pl-4 jlt-flex jlt-items-center jlt-gap-2"
                    href={"/dashboard/support"}
                  >
                    {getStyledIcon(getIcon("support"), "var(--primary)", "stroke", {
                      width: "16px",
                      height: "16px",
                    })}
                    <span className="jlt-text-sm jlt-font-medium">Support</span>
                  </Link>
                  <hr className="jlt-mx-2" />
                  <Link
                    className="jlt-text-[#256EFF] jlt-border-l-0 hover:jlt-border-l-4 jlt-transition-all jlt-duration-100 jlt-border-[#256EFF] jlt-py-1 jlt-pl-4 jlt-flex jlt-items-center jlt-gap-2"
                    href={"/dashboard/profile"}
                  >
                    {getStyledIcon(getIcon("profile"), "var(--primary)", "stroke", {
                      width: "16px",
                      height: "16px",
                    })}
                    <span className="jlt-text-sm jlt-font-medium">Profile</span>
                  </Link>
                  <hr className="jlt-mx-2" />
                  <button
                    className="jlt-text-[#256EFF] jlt-border-l-0 hover:jlt-border-l-4 jlt-transition-all jlt-duration-100 jlt-border-[#256EFF] jlt-py-1 jlt-pl-4 jlt-pb-2 jlt-flex jlt-items-center jlt-gap-2"
                    onClick={() => signOut()}
                  >
                    {getStyledIcon(getIcon("logout"), "var(--primary)", "fill", {
                      width: "14px",
                      height: "14px",
                    })}
                    <span className="jlt-text-sm jlt-font-medium">Logout</span>
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <Link
          href="/dashboard/orders"
          style={{ color: "#fff" }}
          className={cn(
            buttonVariants({ size: "sm" }),
            "jlt-bg-white !jlt-text-black hover:!jlt-text-white hover:!jlt-bg-[var(--primary)] hover:jlt-opacity-85 jlt-transition-all !jlt-duration-150"
          )}
        >
          Account
        </Link>
      )}
    </>
  );
};

export default HeaderAccount;
